import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import popularMakes from 'shared/constants/json/makes.json';
import Title from './Title/Title';
import MakesList from './MakesList/MakesList';
import s from './MakesSidebar.css';

class MakesSidebar extends Component {
  static propTypes = {
    title: PropTypes.string,
    itemCN: PropTypes.string,
    makes: PropTypes.arrayOf(PropTypes.shape().isRequired),
    //
    intl: intlShape.isRequired,
  };

  static defaultProps = {
    makes: popularMakes,
    itemCN: '',
    title: undefined,
  };

  // componentDidMount = () => {
  //   document.addEventListener('scroll', this.handleScrollPage);
  // };

  // handleScrollPage = () => {
  //   console.dir(this.sidebar);
  //   const a = this.sidebar.offsetTop;
  //   const parent = this.sidebar.parentNode;
  //   const { top } = parent.getBoundingClientRect();
  //   if (top < a) {
  //     this.sidebar.style.top = `${-top - a}px`;
  //   }
  // };

  render() {
    const { intl } = this.props;
    const {
      title = intl.formatMessage({ id: 'Популярные марки и модели' }),
      makes,
      itemCN,
    } = this.props;

    return (
      <div className={s.makesSidebar}>
        <Title title={title} />
        <MakesList list={makes} itemCN={itemCN} />
      </div>
    );
  }
}

export default withStyles(s)(injectIntl(MakesSidebar));



// WEBPACK FOOTER //
// ./src/desktop/components/MakesSidebar/MakesSidebar.js